import { createCompositeProvider } from '../common/createProvider';
import { plugins } from './plugins';

export const { run, Component } = createCompositeProvider('fitness', plugins);



// WEBPACK FOOTER //
// ./D:/Repos/university/my-composer/app/plugins/GA/lib/fitness/FitnessProvider.js